import React, { Component } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import Header from './components/Header/';
import HeroSection from './components/HeroSection';
import VideoSlideSection from './components/VideoSlideSection';
import LeadTheWay from './components/LeadTheWay';
import TheChange from './components/TheChange';
import Influence from './components/Influence';
import Footer from './components/Footer/';
import { configureAnchors } from 'react-scrollable-anchor';

configureAnchors({offset: -130, scrollDuration: 200})

const Buffer = (props) => {
  return (
    <div className={props.name + '-buffer'}></div>
  );
};

class App extends Component {
  render() {
    return (
      <div>
        <Buffer name="header" />
        <Header />
        <HeroSection />
        <VideoSlideSection />
        <ScrollableAnchor id={'lead-the-way'}>
          <LeadTheWay />
        </ScrollableAnchor>
        <ScrollableAnchor id={'the-change'}>
          <TheChange />
        </ScrollableAnchor>
        <ScrollableAnchor id={'the-influence'}>
          <Influence />
        </ScrollableAnchor>
        <ScrollableAnchor id={'get-support'}>
          <Footer />
        </ScrollableAnchor>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js